export default class AbstractServices {
  static getMembershipMembers() {
    logger.error(`CRM Common Services:: getMembershipMembers() not implemented`);
  }

  static getMembershipPolicies() {
    logger.error(`CRM Common Services:: getMembershipPolicies() not implemented`);
  }

  static getMigrationDate() {
    logger.error(`CRM Common Services:: getMigrationDate() not implemented`);
  }
}